export class Constants {
    public static readonly Application = 2;

}
